import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileNav: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const activeSlide = location.state?.slide ?? 0;
  const isHome = location.pathname === '/';
  const isProduct = location.pathname === '/installatie-voorbeelden';

  const goToSlide = (index: number) => {
    navigate('/', { state: { slide: index } });
    setMenuOpen(false);
  };

  return (
    <section className="grid-padding-lr">
      <nav className="navbar-bottom">
        {/* Hamburger Button */}
        <div className="hamburger-box">
          <button
            className={`hamburger ${menuOpen ? 'active' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
          <p className="mobile-menu-slogan">
            Cool by nature. <span className="color-sec">Smart by choice.</span>
          </p>

          <ul>
            {/* Main entry */}
            <li>
              <button
                className={`button-transparent color-prim ${isHome ? ' bold' : ''}`}
                onClick={() => goToSlide(0)}
              >
                Comfort begint hier
              </button>
            </li>

            <li>
              <ul className="p-1">
                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 0 ? 'bold' : ''}`}
                    onClick={() => goToSlide(0)}
                  >
                    Meer dan alleen koelen!
                  </button>
                </li>

                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 1 ? 'bold' : ''}`}
                    onClick={() => goToSlide(1)}
                  >
                    Gecertificeerd Koeltechnieker
                  </button>
                </li>

                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 2 ? 'bold' : ''}`}
                    onClick={() => goToSlide(2)}
                  >
                    Installatie & Onderhoud.
                  </button>
                </li>

                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 3 ? 'bold' : ''}`}
                    onClick={() => goToSlide(3)}
                  >
                    Waar wij voor staan.
                  </button>
                </li>

                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 4 ? 'bold' : ''}`}
                    onClick={() => goToSlide(4)}
                  >
                    Wie we zijn!
                  </button>
                </li>

                <li>
                  <button
                    className={`button-transparent color-prim ${isHome && activeSlide === 5 ? 'bold' : ''}`}
                    onClick={() => goToSlide(5)}
                  >
                    Contacteer ons!
                  </button>
                </li>
              </ul>
            </li>

            {/* New page */}
            <li>
              <button
                className={`button-transparent color-prim ${isProduct ? ' bold' : ''}`}
                onClick={() => {
                  navigate('/installatie-voorbeelden');
                  setMenuOpen(false);
                }}
              >
                Installatie voorbeelden
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  );
};

export default MobileNav;
